module.exports = __webpack_public_path__ + "img/lc-logo.4e48d281.svg";